export const columns = () => {
  return [
    {
      id: "sport.code",
      accessorFn: (row) =>
        row.sport.code && `${row.sport.code} - ${row.sport.name}`,
      header: "Sport",
    },
    {
      id: "product_group.code",
      accessorFn: (row) =>
        row.product_group.code &&
        `${row.product_group.code} - ${row.product_group.name}`,
      header: "Product Group",
    },
    {
      id: "parent_product_category.code",
      accessorFn: (row) =>
        row.parent_product_category.code &&
        `${row.parent_product_category.code} - ${row.parent_product_category.name}`,
      header: "Parent Product Category",
    },
    {
      id: "product_category.code",
      accessorFn: (row) =>
        row.product_category.code &&
        `${row.product_category.code} - ${row.product_category.name}`,
      header: "Product Category",
    },
    {
      id: "product.code",
      accessorFn: (row) =>
        row.product.code && `${row.product.code} - ${row.product.name}`,
      header: "Product",
    },
  ];
};
